import React, { useEffect, useState } from 'react';
import { Avatar, Button, Modal, theme } from 'antd';
import { PlusOutlined, UserOutlined } from '@ant-design/icons';
import { PageHeader, SectionHeader } from 'components/headings';
import AddTenantForm from 'components/forms/AddTenantForm';
import TenantsTable from 'components/tables/TenantsTable';
import useAuth from 'hooks/useAuth';
import dayjs from 'libs/dayjs';
import { useTenants } from 'providers/Tenant/TenantProvider';

const { useToken } = theme;

const Inicio = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { token } = useToken();
  const { call: callTenants, hasCalled: hasCalledTenants } = useTenants();

  useEffect(() => {
    if (!hasCalledTenants) callTenants();
  }, [callTenants, hasCalledTenants]);

  const onSuccessTenant = () => {
    setOpen(false);
    callTenants();
  };

  const today = dayjs().format('dddd D [de] MMMM, YYYY');
  const dayOfWeek = dayjs().format('dddd');

  return (
    <div
      style={{
        padding: token.paddingLG,
        paddingBottom: token.paddingXL,
        display: 'flex',
        flexDirection: 'column',
        gap: token.marginLG,
      }}
    >
      <PageHeader
        title={`¡Buen día, ${user?.fullname ?? ''}!`}
        subtitle={`${today} — ten un excelente ${dayOfWeek}`}
        actions={
          <Avatar
            size={56}
            icon={<UserOutlined />}
            style={{ background: token.colorPrimary }}
            aria-hidden="true"
          />
        }
      />

      <section>
        <SectionHeader
          title="Tenants"
          subtitle="Organizaciones registradas en la plataforma"
          actions={
            <Button onClick={() => setOpen(true)} type="primary" icon={<PlusOutlined />}>
              Agregar tenant
            </Button>
          }
        />
        <TenantsTable />
      </section>

      <Modal
        onCancel={() => setOpen(false)}
        open={open}
        footer={false}
        title="Agregar Tenant"
        destroyOnHidden
      >
        <AddTenantForm onSuccess={onSuccessTenant} />
      </Modal>
    </div>
  );
};

export default Inicio;
